<!--suppress HtmlUnknownTag -->
<template>
    <div style="height: 100%;display: flex;flex-direction: row;justify-content: center;">
        <el-col :lg="8" :md="12" :sm="18">
            <el-form label-width="80px" label-position="left" :model="$store.state.loginUser" style="margin-top: 100px">
                <el-form-item label="" style="text-align: center">
                    <img width="100px" avatar ondragstart="return false" oncontextmenu="return false"
                         :src="$store.state.backendHost+$store.state.loginUser.img.split(',')[0]" alt="" @error="userImgDefalt">
                </el-form-item>
                <el-form-item label="用户名">
                    <el-input v-model="user.username"></el-input>
                </el-form-item>
                <el-form-item label="密码">
                    <el-input type="password" v-model="user.password"></el-input>
                </el-form-item>
                <el-form-item label="头像">
                    <MultiImgUploader v-model="$store.state.loginUser.img"></MultiImgUploader>
                    
                </el-form-item>
                <el-form-item label="">
                    <el-button style="width: 100%" type="primary" @click="update">修改</el-button>
                </el-form-item>
            </el-form>
        </el-col>
    </div>
</template>

<script>
import MultiImgUploader from "@/components/MultiImgUploader.vue";

export default {
    name: "Self",
    components: {MultiImgUploader},
    watch: {
        "$store.state.loginUser": {
            deep: true,
            handler: function (n, o) {
                this.user = n
            }
        }
    },
    data() {
        return {
            mode: this.$route.fullPath.split('/')[1],
            user:this.$store.state.loginUser
        }
    },

    methods: {
        update() {
            this.loading = true
            let data = JSON.stringify(this.user)
            this.$axios({
                url: '/user/update',
                method: 'post',
                headers: {'content-type': 'application/json'},
                data: data,
            }).then((r) => {
                if (r.data === 1) {
                    this.$store.commit("setUser", this.user)
                    this.$message.success('修改成功');
                } else {
                    this.$message.error('修改失败');
                }
                this.loading = false
            })
        },

        submitUpload() {
            this.$refs.upload.submit()
        },
        uploadSucc(response, file) {
            this.user.img = response
        },
    }
}
</script>

<style scoped>

</style>